import { render, staticRenderFns } from "./AuctionHistoryModal.vue?vue&type=template&id=66c51267&scoped=true&"
import script from "./AuctionHistoryModal.vue?vue&type=script&lang=js&"
export * from "./AuctionHistoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c51267",
  null
  
)

export default component.exports